import React, { useRef } from 'react';
import { Outlet } from 'react-router-dom';
import { Scrollbar } from '@ann/web-components';
import { DashboardScrollProvider } from './context/DashboardScrollContext';
import { Container, ScrollArea } from './DashboardBuilderPage.styled';

const DashboardBuilderPage = () => {
  const scrollContainerRef = useRef(null);

  return (
    <DashboardScrollProvider scrollContainerRef={scrollContainerRef}>
      <Container>
        <ScrollArea>
          <Scrollbar size="small" padding="0" parentRef={scrollContainerRef} style={{ height: '100%', width: '100%' }}>
            <Outlet />
          </Scrollbar>
        </ScrollArea>
      </Container>
    </DashboardScrollProvider>
  );
};

export default DashboardBuilderPage;
